import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {
  defaults() {
    return {
      loaderImage : 'assets/images/loader.gif',
      masterType :  {
        'bucket': 'bucketmaster',
        'bankName': 'BankName',
        'product': 'Products',
        'state': 'State',
        'agencyType': 'AgencyType'
      },
      region: ['All', 'North', 'South', 'East', 'West'],
      agentStatus :   [{id: 2, description: 'Pending Approval'},
        { id: 3, description: 'Saved as Draft'},
        { id: 4, description: 'Approved'},
        { id: 5, description: 'Rejected'},
        { id: 13, description: 'Black listed'},
        { id: 6, description: 'Disabled'},
        { id: 12, description: 'Pending Mobile Approvals'},
        { id: 10, description: 'ID Card Expired'}],
      agencyStatus : [{ id: 2, description: 'Pending Approval'},
        { id: 3, description: 'Saved as Draft'},
        { id: 4, description: 'Approved'},
        { id: 5, description: 'Rejected'},
        { id: 13, description: 'Black listed'},
        { id: 6, description: 'Disabled'},
        { id: 9, description: 'Contract Expired'},
        { id: 7, description: 'Approved With Deferrals'},
        { id: 11, description: 'Pending Approval With Deferrals'}],
      paymentModes : ['CASH', 'CHEQUE', 'DD'],
      empanelmentDocsAgency : [
        {
          'id': 16,
          'identificationType': 'Signed Agreement',
          'identificationDocTypes': [{'id': 33,  'identificationDoc': 'Not Applicable' }],
          'required' : true
        },
        {
          'id': 17,
          'identificationType': 'KYC ID Proof',
          'identificationDocTypes': [{ 'id': 38, 'identificationDoc': 'Pan Card'},
            { 'id': 39, 'identificationDoc': 'Driving Licence'},
            { 'id': 40, 'identificationDoc': 'Aadhar Card'},
            { 'id': 41, 'identificationDoc': 'Voter Card'},
            { 'id': 42, 'identificationDoc': 'Others'}],
          'required' : true
        },
        {
          'id': 18,
          'identificationType': 'KYC Address Proof',
          'identificationDocTypes': [{ 'id': 43, 'identificationDoc': 'Driving Licence'},
            { 'id': 44, 'identificationDoc': 'Aadhar Card'},
            { 'id': 45, 'identificationDoc': 'Ration Card'},
            { 'id': 46, 'identificationDoc': 'Others'}],
          'required' : true
        },
        {
          'id': 19,
          'identificationType': 'Verification Report',
          'identificationDocTypes': [{'id': 34,  'identificationDoc': 'Not Applicable' }],
          'required' : true
        },
        {
          'id': 20,
          'identificationType': 'Recomendation Letter',
          'identificationDocTypes': [{'id': 35,  'identificationDoc': 'Not Applicable' }],
          'required' : true
        },
        {
          'id': 21,
          'identificationType': 'Proof of Bank Details',
          'identificationDocTypes': [{'id': 36,  'identificationDoc': 'Not Applicable' }],
          'required' : true
        },
        {
          'id': 22,
          'identificationType': 'Proof of Financial Details/ITR',
          'identificationDocTypes': [{'id': 37,  'identificationDoc': 'Not Applicable' }],
          'required' : false
        }
      ],
      empanelmentDocsAgent : [
        {
          'id': 1,
          'identificationType': 'ID Proof',
          'identificationDocTypes': [{ 'id': 1, 'identificationDoc': 'Pan Card'},
            { 'id': 2, 'identificationDoc': 'Driving Licence'},
            { 'id': 3, 'identificationDoc': 'Aadhar Card'},
            { 'id': 4, 'identificationDoc': 'Voter Card'},
            { 'id': 5, 'identificationDoc': 'Others'}],
          'required' : true
        },
        {
          'id': 2,
          'identificationType': 'Address Proof',
          'identificationDocTypes': [{ 'id': 6, 'identificationDoc': 'Driving Licence'},
            { 'id': 7, 'identificationDoc': 'Aadhar Card'},
            { 'id': 8, 'identificationDoc': 'Ration Card'},
            { 'id': 9, 'identificationDoc': 'Others'}],
          'required' : true
        },
        {
          'id': 3,
          'identificationType': 'Agency ID Card',
          'identificationDocTypes': [{'id': 10,  'identificationDoc': 'Not Applicable' }],
          'required' : true
        },
        {
          'id': 10,
          'identificationType': 'HOC Approval',
          'identificationDocTypes': [{'id': 17,  'identificationDoc': 'Not Applicable' }],
          'required' : true
        },
        {
          'id': 4,
          'identificationType': 'Bio Data',
          'identificationDocTypes': [{'id': 11,  'identificationDoc': 'Not Applicable' }],
          'required' : false
        },
        {
          'id': 5,
          'identificationType': 'Cancelled Cheque',
          'identificationDocTypes': [{'id': 12,  'identificationDoc': 'Not Applicable' }],
          'required' : false
        },
        {
          'id': 6,
          'identificationType': 'Cibil Check',
          'identificationDocTypes': [{'id': 13,  'identificationDoc': 'Not Applicable' }],
          'required' : false
        },
        {
          'id': 7,
          'identificationType': 'Code Of Conduct',
          'identificationDocTypes': [{'id': 14,  'identificationDoc': 'Not Applicable' }],
          'required' : false
        },
        {
          'id': 8,
          'identificationType': 'Form 11(PFA)',
          'identificationDocTypes': [{'id': 15,  'identificationDoc': 'Not Applicable' }],
          'required' : false
        },
        {
          'id': 9,
          'identificationType': 'Fraud Check Report (FCU)',
          'identificationDocTypes': [{'id': 16,  'identificationDoc': 'Not Applicable' }],
          'required' : false
        },
        {
          'id': 11,
          'identificationType': 'New Joinee Request(PFA) (Branch & Product Mapping)',
          'identificationDocTypes': [{'id': 18,  'identificationDoc': 'Not Applicable' }],
          'required' : false
        },
        {
          'id': 12,
          'identificationType': 'Police Verification Report',
          'identificationDocTypes': [{'id': 19,  'identificationDoc': 'Not Applicable' }],
          'required' : false
        },
        {
          'id': 13,
          'identificationType': 'Qualification Details',
          'identificationDocTypes': [{ 'id': 20, 'identificationDoc': '10th Marksheet' },
            { 'id': 21, 'identificationDoc': '12th Marksheet'},
            { 'id': 22, 'identificationDoc': 'Graduation Degree'},
            { 'id': 23, 'identificationDoc': 'Graduation Marksheet'},
            { 'id': 24, 'identificationDoc': 'Post Graduation Degree'},
            { 'id': 25, 'identificationDoc': 'Post Graduation Marksheet'},
            { 'id': 26, 'identificationDoc': 'Others'}],
          'required' : false
        },
        {
          'id': 14,
          'identificationType': 'Reference Letter',
          'identificationDocTypes': [{'id': 27,  'identificationDoc': 'Not Applicable' }],
          'required' : false
        },
        {
          'id': 15,
          'identificationType': 'Proof Of Last Employment',
          'identificationDocTypes': [ { 'id': 28, 'identificationDoc': 'Salary Slip' },
            { 'id': 29, 'identificationDoc': 'Appointment Letter'},
            { 'id': 30, 'identificationDoc': 'Relieving Letter'},
            { 'id': 31, 'identificationDoc': 'Bank Statement'},
            { 'id': 32, 'identificationDoc': 'Others'}],
          'required' : false
        }
      ],

      letterStatus : ['Generated', 'Dispatched', 'Delivery Confirmed', 'Returned'],
      duration : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 18, 24],

      lastLetterSend : ['Last month', 'Last 3 months', 'Last 6 months'],

      buckets : [ '0', '1', '2', '3', '4', 'Coff'],

      com_templates : [
        'DunningLetter1CFHFPL',
        'DunningLetter1CFL',
        'DunningLetter1CitiPool',
        'DunningLetter2CitiPool',
        'DunningLetters2CFHFPL',
        'DunningLetters2CFL'
      ],

      com_channel : ['Letter'],

      batch_actions : ['Upload Dispatch Details', 'Upload Return Details'],

      dispGroupCodes : [
        'Situational NC',
        'Dialer Related',
        'Pure NC',
        'Customer will pay',
        'Dispute',
        'Call Back',
        'Third Party contacted (TPC)',
        'Reported Paid',
        'Refuse to Pay',
        'Broken PTP',
        'SETTLEMENT',
        'Skip',
        'Trace'
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/config.service.ts